var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "formRef",
      attrs: {
        model: _vm.form,
        rules: _vm.rules,
        "label-width": "150px",
        size: "small",
      },
    },
    [
      _c(
        "el-form-item",
        { attrs: { label: "店铺：", prop: "storeId" } },
        [
          _c(
            "el-select",
            {
              staticClass: "form-width",
              attrs: {
                placeholder: "请选择店铺",
                filterable: "",
                clearable: "",
                disabled: _vm.isEditMode,
              },
              on: { change: _vm.onStoreChange },
              model: {
                value: _vm.form.storeId,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "storeId", $$v)
                },
                expression: "form.storeId",
              },
            },
            _vm._l(_vm.storeOptions, function (item) {
              return _c("el-option", {
                key: item.value,
                attrs: { label: item.label, value: item.value },
              })
            }),
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "商品分类：", prop: "cateId" } },
        [
          _c("el-cascader", {
            staticClass: "form-width",
            attrs: {
              options: _vm.categoryOptions,
              props: _vm.cascaderProps,
              placeholder: "请选择商品分类",
              clearable: "",
              "show-all-levels": true,
              separator: " / ",
            },
            model: {
              value: _vm.form.cateId,
              callback: function ($$v) {
                _vm.$set(_vm.form, "cateId", $$v)
              },
              expression: "form.cateId",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "店铺商品类目：", prop: "showCateId" } },
        [
          _c("el-cascader", {
            staticClass: "form-width",
            attrs: {
              options: _vm.displayCategoryOptions,
              props: Object.assign({}, _vm.cascaderProps, { multiple: true }),
              placeholder: "请选择店铺商品类目",
              clearable: "",
              "show-all-levels": true,
              separator: " / ",
            },
            model: {
              value: _vm.form.showCateId,
              callback: function ($$v) {
                _vm.$set(_vm.form, "showCateId", $$v)
              },
              expression: "form.showCateId",
            },
          }),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "ml10",
              attrs: { type: "primary", size: "mini" },
              on: { click: _vm.goToCategoryManage },
            },
            [_vm._v("添加店铺商品类目")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "购买方式：", prop: "wmTgFlag" } },
        [
          _c(
            "el-select",
            {
              staticClass: "form-width",
              attrs: {
                placeholder: "请选择购买方式",
                clearable: "",
                filterable: "",
                disabled: _vm.isEditMode,
              },
              on: { change: _vm.wmTgFlagChange },
              model: {
                value: _vm.form.wmTgFlag,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "wmTgFlag", $$v)
                },
                expression: "form.wmTgFlag",
              },
            },
            _vm._l(_vm.wmTgFlagOptions, function (item) {
              return _c("el-option", {
                key: item.value,
                attrs: { label: item.label, value: item.value },
              })
            }),
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.form.storeId && _vm.form.wmTgFlag
        ? _c(
            "el-form-item",
            { attrs: { label: "店铺类型：", prop: "storeType", required: "" } },
            [
              _c(
                "el-select",
                {
                  staticClass: "form-width",
                  attrs: {
                    placeholder: "请选择店铺类型",
                    clearable: "",
                    filterable: "",
                    disabled: _vm.storeTypeOptions.length === 0,
                  },
                  model: {
                    value: _vm.form.storeType,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "storeType", $$v)
                    },
                    expression: "form.storeType",
                  },
                },
                _vm._l(_vm.storeTypeOptions, function (item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value },
                  })
                }),
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.frtTemplateFlag
        ? _c(
            "el-form-item",
            { attrs: { label: "运费模板：", prop: "frtTemplateId" } },
            [
              _c(
                "el-select",
                {
                  staticClass: "form-width",
                  attrs: {
                    placeholder: "请选择运费模板",
                    clearable: "",
                    filterable: "",
                  },
                  model: {
                    value: _vm.form.frtTemplateId,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "frtTemplateId", $$v)
                    },
                    expression: "form.frtTemplateId",
                  },
                },
                _vm._l(_vm.frtTemplateOptions, function (item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value },
                  })
                }),
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "SPU名称：", prop: "spuName" } },
        [
          _c("el-input", {
            staticClass: "form-width",
            attrs: { placeholder: "请输入" },
            model: {
              value: _vm.form.spuName,
              callback: function ($$v) {
                _vm.$set(_vm.form, "spuName", $$v)
              },
              expression: "form.spuName",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "排序：", prop: "sort" } },
        [
          _c("el-input", {
            staticClass: "form-width",
            attrs: { placeholder: "请输入", clearable: "" },
            nativeOn: {
              keydown: function ($event) {
                return _vm.blockSortDecimal($event)
              },
            },
            model: {
              value: _vm.sortDisplay,
              callback: function ($$v) {
                _vm.sortDisplay = $$v
              },
              expression: "sortDisplay",
            },
          }),
          _vm._v(" "),
          _c("span", { staticClass: "sort-tip" }, [
            _vm._v("整数，可不填，支持负数"),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c("el-form-item", { attrs: { label: "主图：" } }, [
        _c("div", { staticClass: "upload-box" }, [
          _c(
            "div",
            {
              staticClass: "upload-item",
              on: { click: _vm.handleMainImageUpload },
            },
            [
              _vm.form.image
                ? _c("div", { staticClass: "upload-preview" }, [
                    _c("img", { attrs: { src: _vm.form.image, alt: "主图" } }),
                    _vm._v(" "),
                    _c("div", { staticClass: "upload-overlay" }, [
                      _c("i", { staticClass: "el-icon-edit" }),
                      _vm._v(" "),
                      _c("span", [_vm._v("更换图片")]),
                    ]),
                  ])
                : _c("div", { staticClass: "upload-placeholder" }, [
                    _c("i", { staticClass: "el-icon-plus" }),
                    _vm._v(" "),
                    _c("p", [_vm._v("选择主图")]),
                  ]),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("el-form-item", { attrs: { label: "商品轮播图：" } }, [
        _c(
          "div",
          { staticClass: "upload-box" },
          [
            _vm._l(_vm.form.sliderImage, function (image, index) {
              return _c("div", { key: index, staticClass: "upload-item" }, [
                _c("div", { staticClass: "upload-preview" }, [
                  _c("img", {
                    attrs: { src: image, alt: "轮播图" + (index + 1) },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "upload-overlay" }, [
                    _c("i", {
                      staticClass: "el-icon-delete",
                      on: {
                        click: function ($event) {
                          return _vm.removeCarouselImage(index)
                        },
                      },
                    }),
                  ]),
                ]),
              ])
            }),
            _vm._v(" "),
            _vm.form.sliderImage.length < 9
              ? _c(
                  "div",
                  {
                    staticClass: "upload-item",
                    on: { click: _vm.handleCarouselImageUpload },
                  },
                  [
                    _c("div", { staticClass: "upload-placeholder" }, [
                      _c("i", { staticClass: "el-icon-plus" }),
                      _vm._v(" "),
                      _c("p", [_vm._v("添加图片")]),
                    ]),
                  ]
                )
              : _vm._e(),
          ],
          2
        ),
        _vm._v(" "),
        _c("div", { staticClass: "upload-tips" }, [
          _c("p", [_vm._v("最多可上传9张图片")]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "品牌：", prop: "brandId" } },
        [
          _c(
            "el-select",
            {
              staticClass: "form-width",
              attrs: { placeholder: "请选择品牌" },
              on: { change: _vm.handleBrandChange },
              model: {
                value: _vm.form.brandId,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "brandId", $$v)
                },
                expression: "form.brandId",
              },
            },
            _vm._l(_vm.brandOptions, function (item) {
              return _c("el-option", {
                key: item.value,
                attrs: { label: item.label, value: item.value },
              })
            }),
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "商品状态：", prop: "status" } },
        [
          _c(
            "el-radio-group",
            {
              model: {
                value: _vm.form.status,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "status", $$v)
                },
                expression: "form.status",
              },
            },
            [
              _c("el-radio", { attrs: { label: 1 } }, [_vm._v("上架")]),
              _vm._v(" "),
              _c("el-radio", { attrs: { label: 0 } }, [_vm._v("下架")]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "必选商品：", prop: "isMust" } },
        [
          _c(
            "el-radio-group",
            {
              model: {
                value: _vm.form.isMust,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "isMust", $$v)
                },
                expression: "form.isMust",
              },
            },
            [
              _c("el-radio", { attrs: { label: 1 } }, [_vm._v("是")]),
              _vm._v(" "),
              _c("el-radio", { attrs: { label: 0 } }, [_vm._v("否")]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      Number(_vm.form.wmTgFlag) === 2
        ? _c(
            "el-form-item",
            {
              attrs: {
                label: "购买是否预约时间：",
                prop: "appointmentTimeFlag",
              },
            },
            [
              _c(
                "el-radio-group",
                {
                  attrs: { disabled: _vm.isEditMode },
                  model: {
                    value: _vm.form.appointmentTimeFlag,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "appointmentTimeFlag", $$v)
                    },
                    expression: "form.appointmentTimeFlag",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: 1 } }, [_vm._v("是")]),
                  _vm._v(" "),
                  _c("el-radio", { attrs: { label: 0 } }, [_vm._v("否")]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "SPU编码：", prop: "spuCode" } },
        [
          _c("el-input", {
            staticClass: "form-width",
            attrs: {
              placeholder: "自动生成或手动填写，不可重复",
              disabled: "",
            },
            model: {
              value: _vm.form.spuCode,
              callback: function ($$v) {
                _vm.$set(_vm.form, "spuCode", $$v)
              },
              expression: "form.spuCode",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "商品标签：" } },
        [
          _c(
            "el-select",
            {
              staticClass: "form-width",
              attrs: { multiple: "", placeholder: "请选择标签", clearable: "" },
              on: { change: _vm.handleLabelChange },
              model: {
                value: _vm.form.tags,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "tags", $$v)
                },
                expression: "form.tags",
              },
            },
            _vm._l(_vm.labelOptions, function (item) {
              return _c("el-option", {
                key: item.value,
                attrs: { label: item.label, value: item.value },
              })
            }),
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.showValidityConfig
        ? _c(
            "el-form-item",
            { attrs: { label: "项目有效期：", prop: "validityFlag" } },
            [
              _c(
                "el-radio-group",
                {
                  on: { change: _vm.onValidityChange },
                  model: {
                    value: _vm.form.validityFlag,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "validityFlag", $$v)
                    },
                    expression: "form.validityFlag",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: 1 } }, [_vm._v("永久")]),
                  _vm._v(" "),
                  _c("el-radio", { attrs: { label: 2 } }, [
                    _vm._v("购买几日后有效"),
                  ]),
                  _vm._v(" "),
                  _c("el-radio", { attrs: { label: 3 } }, [
                    _vm._v("指定有效日期"),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.form.validityFlag === 2 && _vm.showValidityConfig
        ? _c(
            "el-form-item",
            {
              attrs: {
                label: "有效期（天）：",
                prop: "validityDays",
                rules: [
                  { validator: _vm.validateDays, trigger: ["change", "blur"] },
                ],
              },
            },
            [
              _c("el-input-number", {
                attrs: { min: 0, max: 365, step: 1, "step-strictly": true },
                model: {
                  value: _vm.form.validityDays,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "validityDays", $$v)
                  },
                  expression: "form.validityDays",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.form.validityFlag === 3 && _vm.showValidityConfig
        ? _c(
            "el-form-item",
            {
              attrs: {
                label: "开始时间：",
                prop: "validityStartTime",
                rules: [
                  { validator: _vm.validateDateRange, trigger: "change" },
                ],
              },
            },
            [
              _c("el-date-picker", {
                staticClass: "form-width",
                attrs: {
                  type: "datetime",
                  "value-format": "yyyy-MM-dd HH:mm:ss",
                  placeholder: "请选择开始时间",
                },
                model: {
                  value: _vm.form.validityStartTime,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "validityStartTime", $$v)
                  },
                  expression: "form.validityStartTime",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.form.validityFlag === 3 && _vm.showValidityConfig
        ? _c(
            "el-form-item",
            {
              attrs: {
                label: "结束时间：",
                prop: "validityEndTime",
                rules: [
                  { validator: _vm.validateDateRange, trigger: "change" },
                ],
              },
            },
            [
              _c("el-date-picker", {
                staticClass: "form-width",
                attrs: {
                  type: "datetime",
                  "value-format": "yyyy-MM-dd HH:mm:ss",
                  placeholder: "请选择结束时间",
                },
                model: {
                  value: _vm.form.validityEndTime,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "validityEndTime", $$v)
                  },
                  expression: "form.validityEndTime",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "服务内容：", prop: "serviceType" } },
        [
          _c(
            "el-select",
            {
              staticClass: "form-width",
              attrs: {
                multiple: "",
                filterable: "",
                placeholder: "请选择",
                clearable: "",
              },
              model: {
                value: _vm.form.serviceType,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "serviceType", $$v)
                },
                expression: "form.serviceType",
              },
            },
            [
              _c("el-option", {
                attrs: { label: "支持售后", value: "支持售后" },
              }),
              _vm._v(" "),
              _c("el-option", { attrs: { label: "随时退", value: "随时退" } }),
              _vm._v(" "),
              _c("el-option", {
                attrs: { label: "过期自动退", value: "过期自动退" },
              }),
              _vm._v(" "),
              _c("el-option", {
                attrs: { label: "7天无理由退款", value: "7天无理由退款" },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }